var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkPrice(_vm.price.value)
    ? _c("section", { staticClass: "calculate-credit-block" }, [
        _c("div", { staticClass: "wrapper" }, [
          _c(
            "h2",
            [_vm._t("section-title", [_vm._v("Рассчитайте ипотеку онлайн")])],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "calculate-credit-block__container" },
            [
              _c(
                "div",
                { staticClass: "sliders" },
                [
                  _c("no-ui-slider", {
                    attrs: {
                      title: "Стоимость квартиры",
                      min: _vm.price.min,
                      max: _vm.price.max,
                      step: _vm.price.step,
                      start: _vm.price.start,
                      postfix: "руб",
                      view: _vm._f("threeDigits")(_vm.price.value)
                    },
                    model: {
                      value: _vm.price.value,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "value", $$v)
                      },
                      expression: "price.value"
                    }
                  }),
                  _vm._v(" "),
                  _c("no-ui-slider", {
                    ref: "deposit",
                    attrs: {
                      title: "Первоначальный взнос",
                      min: _vm.deposit.min,
                      max: _vm.deposit.max,
                      step: _vm.deposit.step,
                      start: _vm.deposit.start,
                      postfix: "руб",
                      view: _vm._f("threeDigits")(_vm.deposit.value)
                    },
                    model: {
                      value: _vm.deposit.value,
                      callback: function($$v) {
                        _vm.$set(_vm.deposit, "value", $$v)
                      },
                      expression: "deposit.value"
                    }
                  }),
                  _vm._v(" "),
                  _c("no-ui-slider", {
                    attrs: {
                      title: "Срок",
                      min: _vm.time.min,
                      max: _vm.time.max,
                      step: _vm.time.step,
                      start: _vm.time.start,
                      postfix: "",
                      view: _vm._f("russianYears")(_vm.time.value)
                    },
                    model: {
                      value: _vm.time.value,
                      callback: function($$v) {
                        _vm.$set(_vm.time, "value", $$v)
                      },
                      expression: "time.value"
                    }
                  }),
                  _vm._v(" "),
                  _c("no-ui-slider", {
                    attrs: {
                      title: "Ставка",
                      min: _vm.rate.min,
                      max: _vm.rate.max,
                      step: _vm.rate.step,
                      start: _vm.rate.start,
                      postfix: "%",
                      view: _vm.rate.value
                    },
                    model: {
                      value: _vm.rate.value,
                      callback: function($$v) {
                        _vm.$set(_vm.rate, "value", $$v)
                      },
                      expression: "rate.value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              [
                _c("div", { staticClass: "results" }, [
                  _c(
                    "span",
                    { staticClass: "title" },
                    [
                      _vm._t("results-title", [
                        _vm._v("Стоимость квартиры в ипотеку")
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sum" }, [
                    _c("p", [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("threeDigits")(_vm.price.value)) + " "
                        ),
                        _c("i", { staticClass: "ruble" })
                      ]),
                      _vm._v(" "),
                      _c("small", [_vm._v("Общая сумма")])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("threeDigits")(_vm.payment)) + " "
                        ),
                        _c("i", { staticClass: "ruble" })
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "foot" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button-pill filled",
                        attrs: { "data-modal": "#creditPopup" }
                      },
                      [_vm._v("Оставить заявку на квартиру")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "foot__info" },
                      [
                        _vm._t("caption", [
                          _c("p", [
                            _vm._v(
                              "Пример расчета процентной ставки носит исключительно информационный характер и не является публичной офертой"
                            )
                          ])
                        ])
                      ],
                      2
                    )
                  ])
                ])
              ]
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [_c("b", [_vm._v("ЕЖЕМЕСЯЧНЫЙ ПЛАТЕЖ")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }